import { render } from "./EyeSlash.vue?vue&type=template&id=990407ee"
const script = {}
script.render = render

export default script